import React from 'react';
import { Card as AntdCard, Skeleton, Button } from 'antd';
import PropTypes from 'prop-types';
import { formatBytes } from 'util/file';
import DownloadIcon from '@material-ui/icons/GetApp';
import { DocumentItem } from './Item';
import classes from './DocumentItem.module.scss';

export const Card = (props) => {
  const { url, downloadUrl, fileName, loading, fileSize = 0, mimeType } = props;
  return (
    <AntdCard className={classes.card} size="small" bordered={false}>
      {loading ? (
        <Skeleton
          active
          avatar={{ shape: 'square', size: 'large' }}
          paragraph={false}
          title={false}
        />
      ) : (
        <div className={classes.card__content}>
          <AntdCard.Meta
            avatar={<DocumentItem url={url} fileName={fileName} mimeType={mimeType} />}
            title={fileName}
            description={formatBytes(fileSize)}
          />
          <div>
            <a href={downloadUrl || url} target="_blank" rel="noreferrer">
              <Button type="text" icon={<DownloadIcon />} />
            </a>
          </div>
        </div>
      )}
    </AntdCard>
  );
};

Card.propTypes = {
  url: PropTypes.string.isRequired,
  downloadUrl: PropTypes.string,
  fileName: PropTypes.string.isRequired,
  fileSize: PropTypes.number,
  mimeType: PropTypes.string,
  loading: PropTypes.bool,
};

Card.defaultProps = {
  fileSize: 0,
  loading: false,
  mimeType: '',
  downloadUrl: '',
};
